var map = {
	"./cs.json": 27800,
	"./da.json": 36509,
	"./de.json": 33385,
	"./en-GB.json": 56645,
	"./en.json": 81805,
	"./es.json": 87110,
	"./fr-CA.json": 7357,
	"./fr.json": 69374,
	"./it.json": 88327,
	"./ja.json": 68931,
	"./ko.json": 62180,
	"./nl.json": 66320,
	"./no.json": 7437,
	"./pl.json": 90442,
	"./pt-BR.json": 89317,
	"./ru.json": 85191,
	"./sv.json": 95959,
	"./zh-Hans.json": 37599,
	"./zh-Hant.json": 15554
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95333;